/* Only loaded on the cart page. No cart or loyalty writes. */
(function () {
  'use strict';

  var marker = 'maruishi_history';
  var url = new URL(window.location.href);
  window.maruishiCartHistoryRefresh = url.searchParams.get(marker) === '1';
  if (window.maruishiCartHistoryRefresh) {
    url.searchParams.delete(marker);
    window.history.replaceState(window.history.state, '', url.toString());
  }
  // Retain only customer-editable note/delivery fields, never quantities or discounts.
  var draftKey = 'maruishi-cart-history-draft-v1';
  var dirty = Object.create(null);
  var baseline = Object.create(null);
  var selector = 'textarea[name="note"], input[name^="attributes["], select[name^="attributes["], textarea[name^="attributes["]';
  function allowed(field) {
    return field && field.name && field.closest('main') && field.matches(selector) && !field.disabled &&
      ['hidden', 'password', 'file', 'checkbox', 'radio'].indexOf(field.type) === -1;
  }
  document.querySelectorAll(selector).forEach(function (field) { if (allowed(field)) baseline[field.name] = field.value; });
  document.addEventListener('focusin', function (event) { if (allowed(event.target) && !(event.target.name in baseline)) baseline[event.target.name] = event.target.value; }, true);
  function track(event) {
    var field = event.target;
    if (!allowed(field)) return;
    if (!dirty[field.name]) dirty[field.name] = { name: field.name, baseline: field.name in baseline ? baseline[field.name] : (field.defaultValue || '') };
    dirty[field.name].value = field.value;
  }
  document.addEventListener('input', track, true);
  document.addEventListener('change', track, true);
  if (window.maruishiCartHistoryRefresh) {
    try {
      var draft = JSON.parse(sessionStorage.getItem(draftKey) || 'null');
      sessionStorage.removeItem(draftKey);
      if (draft && Date.now() - draft.at < 120000 && draft.path === window.location.pathname) {
        Object.keys(draft.fields).forEach(function (name) {
          var entry = draft.fields[name];
          var field = Array.from(document.querySelectorAll(selector)).find(function (node) { return node.name === name && allowed(node); });
          if (!field || field.value === entry.value) return;
          // A newer server value wins over an older draft from this history entry.
          if (field.value !== entry.baseline) {
            var conflict = document.createElement('p');
            conflict.setAttribute('role', 'status');
            conflict.textContent = 'カートの入力内容が更新されています。戻る前の入力内容：' + entry.value;
            field.parentNode.appendChild(conflict);
            return;
          }
          if (field.tagName === 'SELECT' && !Array.from(field.options).some(function (option) { return option.value === entry.value && !option.disabled; })) return;
          field.value = entry.value;
          dirty[name] = entry;
        });
      }
    } catch (_) { /* Storage is optional when there are no unsaved fields. */ }
  }
  var refreshing = false;
  var main = null;
  var notice = null;
  var wasInert = false;

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted || refreshing) return;
    // Persist drafts before navigation. If storage is unavailable, let the customer
    // preserve the text rather than silently discarding it during an automatic reload.
    try {
      sessionStorage.setItem(draftKey, JSON.stringify({ at: Date.now(), path: window.location.pathname, fields: dirty }));
    } catch (_) {
      if (Object.keys(dirty).length) {
        if (!document.getElementById('maruishi-history-storage-warning')) {
          var warning = document.createElement('p');
          warning.id = 'maruishi-history-storage-warning';
          warning.setAttribute('role', 'alert');
          warning.textContent = 'カートの最新情報を表示するため、入力中のメッセージを控えてから再読み込みしてください。';
          var reloadLink = document.createElement('a');
          var fallback = new URL(window.location.href);
          fallback.searchParams.set(marker, '1');
          reloadLink.href = fallback.toString();
          reloadLink.textContent = ' カートを再読み込み';
          warning.appendChild(reloadLink);
          document.getElementById('main').prepend(warning);
          document.querySelectorAll('button[name="checkout"],input[name="checkout"],a[href*="/checkout"],a[href*="/cart/change"],quantity-selector').forEach(function (node) { node.setAttribute('inert', ''); });
        }
        return;
      }
    }
    refreshing = true;

    main = document.getElementById('main');
    if (main) {
      wasInert = main.hasAttribute('inert');
      main.setAttribute('inert', '');
      notice = document.createElement('div');
      notice.setAttribute('role', 'status');
      notice.style.cssText = 'padding:20px;text-align:center;line-height:1.8';
      notice.appendChild(document.createTextNode('カートの最新情報を確認しています。 '));
      var retry = document.createElement('a');
      retry.href = window.location.href;
      retry.textContent = '再読み込み';
      notice.appendChild(retry);
      main.parentNode.insertBefore(notice, main);
    }

    var target = new URL(window.location.href);
    target.searchParams.set(marker, '1');
    window.location.replace(target.toString());
  });

  // Do not store the temporary lock if this document enters history again.
  window.addEventListener('pagehide', function () {
    if (!refreshing) return;
    if (main && !wasInert) main.removeAttribute('inert');
    if (notice) notice.remove();
    refreshing = false;
    main = notice = null;
  });
})();
